/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './Select.css';

function Select({ options, error, completed, ...props }) {
  return (
    <>
      <div className="sn-select">
        <select
          {...props}
          style={{
            color: props.value ? '#000' : '#767676',
          }}
          className={[
            !!error ? 'input-has-error' : '',
            completed ? 'input-completed' : '',
            props.className,
          ].join(' ')}
        >
          {options?.map((opt) => (
            <option
              key={`opt-select-key-${opt.value}-${opt.text}`}
              value={opt.value}
              disabled={opt.disabled}
            >
              {opt.text}
            </option>
          ))}
        </select>
        <span className="ic-container">
          <img src="assets/rastreadores/ic_arrow_down.svg" alt="" />
        </span>
      </div>

      {error && <p className="input-error-text">*{error}</p>}

      <style jsx>{Styles}</style>
    </>
  );
}

export default Select;
